import deepEqual from 'fast-deep-equal/es6/react';
import { useDispatch, useSelector } from 'react-redux';
import { setUsersIntake } from '../../../store/auth/actions';
import { ApplicationState } from '../../../store/index';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ViewDropdown } from 'shared-components';
import { IOption } from 'api-paths-cas';

/**
 * Generalised intakes dropdown component that works with the admissions and cas workflow dashboard.
 *
 * Interfaces with global state to set the intake in the auth state, and to monitor the default intake
 * from the config state.
 */
export const IntakeDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const intakeId = searchParams.get('intakeId');
  const { defaultOption, options, isIntakeVisible } = useSelector(({ config, auth }: ApplicationState) => {
    const currentIntakeValue = intakeId || auth.intake;
    return {
      isIntakeVisible: config.intakeIds.length > 1,
      options: config.intakeIds as IOption[],
      defaultOption: config.intakeIds.find(intake => intake.value === currentIntakeValue) || config.intakeIds[0],
    };
  }, deepEqual);

  const onSelect = (option: IOption): IOption => {
    if (option?.value) {
      const params = new URLSearchParams(window.location.search);
      params.set('page', '1');
      params.set('intakeId', option?.value);
      try {
        localStorage.setItem('dashboard-intake-filter-value', option.value);
      } catch (error) {
        console.warn('Error saving intake filter to localStorage:', error);
      }
      navigate({ search: params.toString() });
      dispatch(setUsersIntake(option.value));
    }
    return option;
  };

  if (!isIntakeVisible) {
    return <></>;
  }

  return <ViewDropdown label="Intake" options={options} defaultOption={defaultOption} onSelect={onSelect} />;
};
